import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const PopularCategoriesSection = styled.section`
	width: 100%;
	padding-block: 64px 102px;
	max-height: 654px;
	overflow: hidden;
	background-color: var(--background-secondary);
	${media.tablet} {
		padding-block: 40px 85px;
		max-height: 588px;
	}
	${media.mobile} {
		padding-block: 24px 36px;
		max-height: 535px;
	}
`;
